const zh = {
  "site.title": "泷泽萝拉——官方资料、作品与最新动态全览",
  "site.description": "泷泽萝拉，日本知名写真偶像与女演员，本页汇聚泷泽萝拉的完整个人资料、出道经历、代表作品、写真集及最新动态。",
  "nav.home": "首页",
  "nav.profile": "个人资料",
  "nav.works": "作品全集",
  "nav.photobook": "写真集",
  "nav.news": "最新动态",
  "nav.about": "关于本站",
  "home.hero.title": "泷泽萝拉",
  "home.hero.subtitle": "日本知名写真偶像与女演员，官方资料、作品与最新动态一站全览",
  "home.featured": "精选文章",
  "home.profile": "个人资料",
  "home.works": "作品全集",
  "home.photobook": "写真集",
  "home.news": "最新动态",
  "home.browse": "按分类浏览文章",
  "home.viewAll": "查看全部",
  "home.loadMore": "查看更多",
  "category.notFound": "分类未找到",
  "category.noArticles": "该分类下暂无文章",
  "category.backHome": "返回首页",
  "article.notFound": "文章未找到",
  "article.related": "相关文章",
  "article.share": "分享这篇文章",
  "article.published": "发布于",
  "article.updated": "更新于",
  "article.readTime": "阅读约 {{minutes}} 分钟",
  "about.title": "关于本站",
  "about.subtitle": "了解泷泽萝拉官方资料站的使命、价值观与联系方式",
  "about.brand": "品牌介绍",
  "about.reputation": "声誉与价值观",
  "about.faq": "常见问题",
  "about.contact": "联系我们",
  "footer.copyright": "泷泽萝拉官方资料站. All rights reserved.",
  "footer.disclaimer": "本站为非官方粉丝资讯网站，所有内容仅供信息参考",
  "breadcrumb.home": "首页",
  "breadcrumb.about": "关于本站",
};

export default zh;